import React, { useState, useRef } from 'react';

import DismissableModal from '../DismissableModal';
import { PawConstants } from '../../lookup/PawConstants';

import Button from 'react-bootstrap/Button';

import Form from 'react-bootstrap/Form';

import './PawStatus.css';
import { FormSelect } from 'react-bootstrap';

const RejectPaw = (props) => {
  const [comments, setComments] = useState("");
  const [pawRejectionReason, setPawRejectionReason] = useState("");
  const [isRejectionReasonSelected, setIsRejectionReasonSelected] = useState(false);
  const [isMandatory, setIsMandatory] = useState(false);
  const [pawRejectionTargetDrugs, setPawRejectionTargetDrugs] = useState([]);
  const [selectTargets, setSelectTargets] = useState(false);
  const [isTargetSelected, setIsTargetSelected] = useState(false);
  const modalRef = useRef(null);

  const { rejectionReasons, targetOptions, rejectionReasonsToNotConsiderTargetDrug, wfId } = props;

  const rejectSwitch = () => {
    if (selectTargets && targetOptions.length === 1) {
      pawRejectionTargetDrugs.push(targetOptions[0].dynamicSwitchOptionId);
    }

    if (isRejectionReasonSelected && (!selectTargets || (selectTargets &&
      pawRejectionTargetDrugs && pawRejectionTargetDrugs.length > 0)) && ((isMandatory && comments) || !isMandatory)) {
      props.attemptStatusUpdate(wfId, PawConstants.status.Rejected, pawRejectionReason, comments);
      modalRef.current.handleClose();
    }
  }

  const setCheckboxValue = (e) => {
    const { value, checked } = e;
    let updatedTargetDrugs;
    if (checked) {
      updatedTargetDrugs = [...pawRejectionTargetDrugs, value];
    } else {
      updatedTargetDrugs = pawRejectionTargetDrugs.filter(item => item !== value);
    }
    setPawRejectionTargetDrugs(updatedTargetDrugs);
    setIsTargetSelected(updatedTargetDrugs.length > 0);
  };

  const renderTargetOption = (t) => {
    return (
      <span>
        {t.faxDisplayName || t.medName}
        &nbsp;({t.medForm})
      </span>
    );
  };

  const setRejectionReason = (e, otherOptionValueForPawRejectionReason) => {
    const reason = e.target.value;
    let shouldSelectTargets = false;
    if (rejectionReasonsToNotConsiderTargetDrug.indexOf(reason) < 0) {
      shouldSelectTargets = true;
    }

    setPawRejectionReason(reason);
    setIsRejectionReasonSelected(!!reason);
    setIsMandatory(reason === otherOptionValueForPawRejectionReason);
    setSelectTargets(shouldSelectTargets);
  };

  const otherOptionValueForPawRejectionReason = 'other';

  const customFooterContent = (
    <div>
      <Button id='switchdetails-btn-reject-cancel' variant="outline-dark" onClick={() => modalRef.current.handleClose()}>Cancel</Button>
      <Button
        id='switchdetails-btn-reject'
        className="left-spacer"
        variant="danger"
        onClick={rejectSwitch}>
        Yes, reject this switch
      </Button>
    </div>
  );
  return (
    <DismissableModal
      ref={modalRef}
      customFooterContent={customFooterContent}
      openModalButtonText="Reject"
      openModalButtonStyle="danger"
      openModalButtonBlock={true}
      openModalButtonDisabled={props.disallowEditing}
      openModalButtonId='switchdetails-btn-reject-popup'
      openModalButtonClassName="btn-block"
      title="Reject Switch" >
      <p className="confirmation-text">
        You have selected to <b>reject</b> this switch.
      </p>
      <p className="text-muted">Once a switch is rejected, its status can't be changed and it won't be communicated to the prescriber.</p>
      <Form.Group >
        <Form.Label>Please select a reason for rejecting this switch</Form.Label>
        <FormSelect
          id='paw-reject-reason'
          value={pawRejectionReason}
          onChange={(e) => setRejectionReason(e, otherOptionValueForPawRejectionReason)}
        >
          <option value="">Select a rejection reason</option>
          {
            rejectionReasons.map((r, i) =>
              <option value={r} key={i}>{i + 1 + ' - ' + r}</option>)
          }
        </FormSelect>
        {
          !isRejectionReasonSelected ? <span className="text-danger smaller-feedback">Rejection reason is mandatory!</span> : <span className="text-success smaller-feedback">Looks good!</span>
        }
      </Form.Group>
      <Form.Group hidden={!selectTargets || targetOptions.length <= 1} >
        <Form.Label>Please select a target drug for rejecting this switch</Form.Label>
        {targetOptions.map((option, id) => (
          <div key={id}>
            {
              <Form.Check
                id={`drug-for-switchrejection${id + 1
                  }`}
                type="checkbox"
                value={option.dynamicSwitchOptionId}
                name="targets"
                style={{ float: "left" }}
                onChange={(e) =>
                  setCheckboxValue(e.target)
                }
              />
            }
            {renderTargetOption(option)}
          </div>
        ))}
        {
          !isTargetSelected ? <span className="text-danger smaller-feedback">Select atleast one drug!</span> : <span className="text-success smaller-feedback">Looks good!</span>
        }

      </Form.Group>
      <Form.Group>
        <Form.Label>Comments</Form.Label>
        <Form.Control
          id='switchdetails-textarea-reject-reason'
          as="textarea"
          rows="2"
          value={comments}
          onChange={(e) => setComments(e.target.value)} />
        <Form.Text className="text-muted">
          {`Notes or comments about this switch ${isMandatory ? '(mandatory)' : '(optional)'}`}
        </Form.Text>
      </Form.Group>
    </DismissableModal>
  );
}

export default RejectPaw;
